/**
 * 接入人机识别，生成前端令牌(_token)
 */
import LibLoader from '../base/lib-loader'

let lib: LibLoader

export default function (url: string): Promise<string> {
  if (!window.Rohr_Opt) {
    window.Rohr_Opt = {
      geo: false,
      reload: () => {},
    }
  }
  return new Promise((resolve) => {
    if (!lib) {
      lib = new LibLoader('rohr_id', 'https://s0.meituan.net/mxx/y/default.js')
    }
    lib.push(() => {
      const _token = window.Rohr_Opt.reload(url)
      resolve(_token)
    })
  })
}
